import React, { useState } from "react";
import { Formik, Field } from "formik";
import { Form, Button } from "react-bootstrap";
import ExcelImage from "../../styles/exportimg.PNG";
import { Image } from "react-bootstrap";
import {
  DatePicker,
  SearchableList,
  FieldDropSide,
  FieldInput,
} from "../../components";
import { usDateFormat } from "../../utils";
import FilterButtons from "./FilterButtons";
import moment from "moment";
import { useDeepEffect, useRequest } from "../../abstracts";
import {
  getPlanList,
  getOutputProfiles,
  getOutputProfileName,
  ExportOutputFiles,
} from "../../services";
import { get, isEmpty } from "lodash";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import FileSaver from "file-saver";
// var today = new Date();
// var lastMonth = new Date(today.setDate(today.getDate() - 30));
const initialValues = {
  planName: null,
  profileName: null,
  mapType: null,
  search: "",
  fromDate: null,
  toDate: null,
};

const allOption = { label: "All", value: null };

function FilterCard({
  FileResponse,
  FileCount,
  values,
  setFieldValue,
  setRequest,
  request,
  setResponse,
  setPlans,
  setStopLoading,
  totalcount,
}) {
  const [planList, setPlanList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const { response: inputResponse } = useRequest({
    method: getOutputProfiles,
    defaultResponse: [],
  });

  const { response: outputResponse } = useRequest({
    method: getOutputProfileName,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    setProfileList([...inputResponse, ...outputResponse]);
  }, [inputResponse, outputResponse]);

  const ActiveInactiveData = [
    {
      label: "Active",
      value: 0,
    },
    {
      label: "In Active",
      value: 1,
    },
  ];
  const mapTypeData = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Output",
      value: "Output File Generation",
    },
    {
      label: "Pass through",
      value: "File Submit",
    },
  ];

  useDeepEffect(() => {
    // setPlanLoading(true);
    getPlanList(0)
      .then((response) => {
        setPlanList(response);
        setPlans(response);
        // setPlanLoading(false);
      })
      .catch((error) => {
        // setPlanLoading(false);
      });
  }, []);
  const DownloadOutputFiles = (values) => {
    var maptype =
      values.mapType == 1
        ? "Output File Generation"
        : values.mapType == 2
        ? "File Submit"
        : null;
    ExportOutputFiles({
      ...request,
      OutputStatus: request.status,
      MapType: maptype,
      DateFrom: request.fromDate,
      DateTo: request.toDate,
      timezoneOffset: new Date().getTimezoneOffset(),
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(
          blob,
          `OutputSummaryReport_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  const filterSearch = (values) => {
    const fromDateRange = values?.fromDate
      ? moment(values?.fromDate)?.format("M/D/YYYY 12:00:00 A")
      : null;
    const toDateRange = values?.toDate
      ? moment(values?.toDate)?.add(12, "hours")?.format("M/D/YYYY 11:59:59 A")
      : null;
    setResponse([]);
    setRequest({
      ...request,
      searchString: values.search,
      rkPlanNumber: values.planName,
      profileName: values.profileName,
      triggeredEvent: get(mapTypeData, values.mapType)?.value,
      fromDate: fromDateRange,
      toDate: toDateRange,
      from: 0,
      mapType: values.mapType,
      trigger: !request?.trigger,
    });
  };

  return (
    <Formik
      initialValues={{
        ...initialValues,
        // ...getFlowBasedFormValues(get(state, formName, {}), flow),
      }}
      onSubmit={filterSearch}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        return (
          <Form
            autoComplete="off"
            className="h-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="mb-3">
              <div className="d-flex flex-row justify-content-between">
                <div>
                  <Field
                    size="smdd"
                    label="Plan name"
                    isRequired
                    noLabelTransform
                    name={"planName"}
                    value={
                      values["planName"] != null
                        ? planList.find(
                            (_) => _.rkPlanNumber == values["planName"]
                          )?.name
                        : "All"
                    }
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        label="Select Plan name"
                        options={
                          planList && [
                            allOption,
                            ...planList.map((plan, index) => {
                              return {
                                label: plan.name,
                                value: plan.rkPlanNumber,
                              };
                            }),
                          ]
                        }
                        onSelect={(value) => {
                          setFieldValue("planName", value);
                        }}
                        selectedValue={values["planName"]}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>

                <div>
                  <Field
                    size="smdd"
                    placeholder="All"
                    isRequired
                    label="Profile name"
                    name={"profileName"}
                    value={values["profileName"]}
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        label="Profile Name"
                        options={[
                          allOption,
                          ...profileList.map((profile, index) => ({
                            label: profile.name,
                            value: index,
                          })),
                        ]}
                        onSelect={(value) => {
                          setFieldValue(
                            "profileName",
                            profileList[value]?.name
                          );
                        }}
                        selectedValue={values["profileName"]}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>
                <div>
                  <Field
                    size="smdd"
                    label="Map Type"
                    isRequired
                    noLabelTransform
                    name={"mapType"}
                    value={
                      values["mapType"] != null
                        ? mapTypeData[values["mapType"]].label
                        : "All"
                    }
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        label="Select Map Type"
                        options={mapTypeData.map((_, index) => ({
                          label: _.label,
                          value: index,
                        }))}
                        onSelect={(value) => {
                          setFieldValue("mapType", value);
                        }}
                        selectedValue={0}
                      />
                    }
                    component={FieldDropSide}
                  />
                </div>

                <div className="d-flex flex-row">
                  <div className="br-0">
                    <Field
                      size="sm"
                      isRequired
                      label="Date range"
                      name="From date"
                      value={usDateFormat(values.fromDate)}
                      isDatePicker
                      placeholder="From date"
                      direction="bottom"
                      onClear={() => {}}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) => {
                            setFieldValue("fromDate", value);
                          }}
                          value={usDateFormat(values.fromDate)}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="bl-0">
                    <Field
                      size="sm"
                      label=""
                      name="To date"
                      isRequired
                      placeholder="To date"
                      value={usDateFormat(values.toDate)}
                      direction="bottom"
                      isDatePicker
                      onClear={() => {
                        setFieldValue("toDate", null);
                        setFieldValue("fromDate", null);
                      }}
                      // onDefaultClearDisplay={values[fields.fromDate]}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) => {
                            setFieldValue("toDate", value);
                          }}
                          value={usDateFormat(values.toDate)}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                </div>
                <Field
                  size="smd"
                  placeholder="Search"
                  name={"search"}
                  label={""}
                  type="text"
                  autoComplete="off"
                  // value={values.search}
                  // onChange={(e) => {
                  //   setFieldValue("searchTerm", e.target.value);
                  // }}
                  component={FieldInput}
                />
                <Button
                  className="ml-5 sort-button"
                  style={{ lineHeight: "19px", marginTop: "30px" }}
                  variant="secondary"
                  type="submit"
                >
                  Search
                </Button>
              </div>
              <span className="ft-14 grey-text font-weight-500 marg-right-5 d-flex justify-content-end">
                <Link
                  style={{ border: "none" }}
                  onClick={() => DownloadOutputFiles(values)}
                >
                  <Image
                    src={ExcelImage}
                    width="18px"
                    style={{ paddingBottom: "3px" }}
                  />
                  Export
                </Link>
              </span>
              <div className="d-flex">
                <FilterButtons
                  request={request}
                  setRequest={setRequest}
                  setResponse={setResponse}
                  setStopLoading={setStopLoading}
                />
                <div className="ml-auto mt-2">
                  {FileCount}/{totalcount} Files
                </div>
              </div>
              <div></div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default FilterCard;
